import { Modal, Button } from "react-bootstrap";

import "./ConditionalModal.scss";
import failIcon from "../../assets/images/failIcon.svg";
import { useEffect, useState } from "react";

const ConditionalModalInviteFail = (props) => {
  const { text } = props;
  console.log('In ConditionalModal')
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600); // Adjust breakpoint as needed
    };

    // Check screen size on component mount
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered={!isMobile}
        className="conditional-modal slide-up-modal"
      >
        <Button
          type="button"
          className="custom-close mobile-close1"
          aria-label="Close"
          onClick={() => {
            props.onHide();
          }}
        >
          <span aria-hidden="true">&times;</span>
        </Button>

        <Modal.Header>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-center w-100"
          ></Modal.Title>
        </Modal.Header>

        <Modal.Body className="mobile-body">
          {
            <>
              <div className="row text-center">
                <div className="col-lg-12">
                  <img src={failIcon} alt="fail icon" />
                </div>

                {text?.length > 0 ? (
                  <>
                    {/* <h1>The User is not registered with our Platform!!</h1> */}
                    <h1>{"Error"}</h1>
                    <p>{text}</p>
                    {/* <p className="greenText">Send Invite</p> */}
                    <p className="greenText"></p>
                  </>
                ) : (
                  <>
                    <h1>The User is not registered with our Platform!!</h1>
                    <p className="modal-para" style={{marginBottom: "15px"}}>
                      Your can send them an invite! Once they join you can add
                      them to your Group.
                    </p>
                    {/* <p className="greenText">Send Invite</p> */}
                  </>
                )}

                <div>
                  <button
                    className="radius0_button"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      props.onHide();
                    }}
                  >
                    Back to Home!
                  </button>
                </div>
              </div>
            </>
          }
        </Modal.Body>

        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};

export default ConditionalModalInviteFail;
